module.exports = __webpack_public_path__ + "img/img-10.7321700f.png";